<script>

import AwardType from '@/views/AadenPages/VipPage/AwardType.vue'
import AllProgress from '@/views/AadenPages/VipPage/UserCenter/AllProgress.vue'

export default {
  name: 'AwardIndex',
  components: {
    AllProgress,
    AwardType
  },
  data () {
    return {
      tab: null
    }
  }
}
</script>

<template>
  <div>
    <v-tabs
      v-model="tab"
      background-color="transparent"
      color="black"
      style="background: transparent"
    >
      <v-tab>AwardType</v-tab>
      <v-tab>AllProgress</v-tab>
    </v-tabs>
    <v-divider />
    <v-tabs-items
      v-model="tab"
      class="mt-4"
      style="background: transparent"
    >
      <v-tab-item>
        <award-type />
      </v-tab-item>
      <v-tab-item>
        <all-progress />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<style scoped>

</style>
